
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"m12.409 14.355 3.091-2.881m0 0-3.091-2.881m3.091 2.88-9.818.035m.039 0a4.24 4.24 0 0 1-2.551-.815 4.08 4.08 0 0 1-1.516-2.164c-.247-.865-.196-1.64.147-2.473A4.1 4.1 0 0 1 3.55 4.067a4.26 4.26 0 0 1 2.627-.537 4.2 4.2 0 0 1 2.42 1.136 4.04 4.04 0 0 1 1.21 2.34c.128.744-.047 1.65-.5 2.431"}})])
          )
        }
      }
    